import '../../sass/blocks/finish-colours.scss';

import cachios from 'cachios';
import { openModal } from '../common/modals';
import { updateSiteHeaderBasketNumber } from '../layouts/site-header';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $finishColours = document.querySelectorAll('.finish-colours');

    if (!$finishColours) return;

    $finishColours.forEach($finishColours => {
        const $swatchBtns = $finishColours.querySelectorAll('.finish-colours-swatch__inner--add-to-cart');
        const $swatchNames = $finishColours.querySelectorAll('.finish-colours-swatch__name');

        // Carousel els
        const $carousel = $finishColours.querySelector('.finish-colours-swatch-carousel');
        const $carouselNavBtns = $finishColours.querySelectorAll('.finish-colours-nav-btn');

        const $finishColoursSwatchWrap = $finishColours.querySelector('.finish-colours-swatch-wrap');

        // Modal els
        const $modal = $finishColours.querySelector('.finish-colours-modal');
        const $modalNumber = $finishColours?.querySelector('.finish-colours-modal__number');
        const $modalName = $finishColours?.querySelector('.finish-colours-modal__name');
        const $modalDescription = $finishColours?.querySelector('.finish-colours-modal__description');
        const $modalDeliveryName = $finishColours?.querySelector('.finish-colours-modal__delivery-name');
        const $modalDeliveryPrice = $finishColours?.querySelector('.finish-colours-modal__delivery-price');
        const $modalDeliveryDuration = $finishColours?.querySelector('.finish-colours-modal__delivery-duration');
        const $modalImage = $finishColours?.querySelector('.finish-colours-modal__image');

        // Modal add to cart els
        const $modalAddToCartForm = $finishColours.querySelector('.finish-colours-modal__add-to-cart-form');
        const $modalAddToCartFormNonce = $modalAddToCartForm?.querySelector('[name=armourcoat_theme_product_add_to_cart_wpnonce]');
        const $modalAddToCartFormProductId = $modalAddToCartForm?.querySelector('[name=product_id]');
        const $modalAddToCartFormFinishId = $modalAddToCartForm?.querySelector('[name=finish_id]');
        const $modalAddToCartFormColourId = $modalAddToCartForm?.querySelector('[name=colour_id]');

        // Swatch panel els
        const $swatchPanel = $finishColours.querySelector('.swatch-panel');
        const $swatchPanelInner = $finishColours.querySelector('.swatch-panel__inner');
        const $swatchPanelNumber = $finishColours?.querySelector('.swatch-panel__number');
        const $swatchPanelName = $finishColours?.querySelector('.swatch-panel__name');
        const $swatchPanelDescription = $finishColours?.querySelector('.swatch-panel__description');
        const $swatchPanelImage = $finishColours?.querySelector('.swatch-panel__image');
        const $swatchPanelDeliveryName = $finishColours?.querySelector('.swatch-panel__delivery-name');
        const $swatchPanelDeliveryPrice = $finishColours?.querySelector('.swatch-panel__delivery-price');
        const $swatchPanelDeliveryDash = $finishColours?.querySelector('.swatch-panel__delivery-dash');
        const $swatchPanelDeliveryDuration = $finishColours?.querySelector('.swatch-panel__delivery-duration');

        // Swatch panel add to cart els
        const $swatchPanelAddToCartForm = $finishColours.querySelector('.swatch-panel__add-to-cart-form');
        const $swatchPanelAddToCartFormNonce = $swatchPanelAddToCartForm?.querySelector('[name=armourcoat_theme_product_add_to_cart_wpnonce]');
        const $swatchPanelAddToCartFormProductId = $swatchPanelAddToCartForm?.querySelector('[name=product_id]');
        const $swatchPanelAddToCartFormFinishId = $swatchPanelAddToCartForm?.querySelector('[name=finish_id]');
        const $swatchPanelAddToCartFormColourId = $swatchPanelAddToCartForm?.querySelector('[name=colour_id]');

        const $addToCartForms = $finishColours.querySelectorAll('.finish-grid-colour__add-to-cart-form');
        
        let addToCartSuccessStateInterval = null;
        let addToCartRemoveSuccessStateTimeout = null;

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                slidesPerView: 'auto',
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });

            if ($carouselNavBtns) {
                $carouselNavBtns.forEach($carouselNavBtn => {
                    $carouselNavBtn.addEventListener('click', () => {
                        const { index } = $carouselNavBtn.dataset;

                        carousel.slideTo(index);
                    });
                });

                carousel.on('slideChange', () => {
                    const $prevActiveCarouselNavBtn = $finishColours.querySelector('.finish-colours-nav-btn--active');

                    if ($prevActiveCarouselNavBtn) {
                        $prevActiveCarouselNavBtn.classList.remove('finish-colours-nav-btn--active');
                    }

                    const $activeCarouselNavBtn = $carouselNavBtns[carousel.activeIndex];

                    if ($activeCarouselNavBtn) {
                        $activeCarouselNavBtn.classList.add('finish-colours-nav-btn--active');
                    }
                });
            }

            const $slides = $carousel.querySelectorAll('.swiper-slide');

            if (carousel && $slides) {
                $slides.forEach(($slide, index) => {
                    const $activeColourSwatch = $slide.querySelector('.finish-colours-swatch__inner--active');

                    if ($activeColourSwatch) {
                        carousel.slideTo(index, 0);
                    }
                })
            }
        };

        const setModalContent = ({
            colourHex,
            colourId,
            colourName,
            colourNumber,
            content,
            delivery,
            finishId,
            image,
            isInCart,
            textColour,
        }) => {
            if (!$modal) return;

            $modal.style.backgroundColor = colourHex ?? '';

            if (textColour === 'light') {
                $modal.classList.add('finish-colours-modal--color-light');
            } else {
                $modal.classList.remove('finish-colours-modal--color-light');
            }

            if ($modalName) {
                $modalName.innerHTML = colourName ?? '';
            }

            if ($modalNumber) {
                $modalNumber.innerHTML = colourNumber ? colourNumber.toString().padStart(3, '0') : '';
            }

            if ($modalDescription) {
                $modalDescription.innerHTML = content ?? '';
            }

            if ($modalAddToCartFormFinishId) {
                $modalAddToCartFormFinishId.value = finishId ?? '';
            }

            if ($modalAddToCartFormColourId) {
                $modalAddToCartFormColourId.value = colourId ?? '';
            }

            if ($modalDeliveryName) {
                $modalDeliveryName.innerHTML = delivery?.name ?? '';
            }

            if ($modalDeliveryPrice) {
                $modalDeliveryPrice.innerHTML = delivery?.price_text ?? '';
            }

            if ($modalDeliveryDuration) {
                $modalDeliveryDuration.innerHTML = delivery?.duration ?? '';
            }

            if ($modalImage) {
                $modalImage.innerHTML = image ?? '';
            }

            $modalAddToCartForm.classList.remove('finish-colours-modal__add-to-cart-form--loading');
            $modalAddToCartForm.classList.add('finish-colours-modal__add-to-cart-form--no-animation');

            if (isInCart) {
                $modalAddToCartForm.classList.add('finish-colours-modal__add-to-cart-form--success');
            } else {
                $modalAddToCartForm.classList.remove('finish-colours-modal__add-to-cart-form--success');
            }

            if (window.innerWidth < 680) {
                openModal($modal);
            }

            setTimeout(() => {
                $modalAddToCartForm.classList.remove('finish-colours-modal__add-to-cart-form--no-animation');
            }, 250);
        };

        const setSwitchPanelContent = ({
            colourHex,
            colourId,
            colourName,
            colourNumber,
            content,
            delivery,
            finishId,
            image,
            isInCart,
            textColour,
        }) => {
            if (!$swatchPanelInner) return;

            $swatchPanelInner.classList.add('swatch-panel__inner--animate-content-change');

            $swatchPanelInner.style.backgroundColor = colourHex ?? '';

            if ($swatchPanelAddToCartFormFinishId) {
                $swatchPanelAddToCartFormFinishId.value = finishId ?? '';
            }

            if ($swatchPanelAddToCartFormColourId) {
                $swatchPanelAddToCartFormColourId.value = colourId ?? '';
            }

            $swatchPanelAddToCartForm.classList.add('swatch-panel__add-to-cart-form--no-animation');

            setTimeout(() => {
                if (isInCart) {
                    $swatchPanelAddToCartForm.classList.add('swatch-panel__add-to-cart-form--success');
                } else {
                    $swatchPanelAddToCartForm.classList.remove('swatch-panel__add-to-cart-form--success');
                }
    
                if (textColour === 'light') {
                    $swatchPanelInner.classList.add('swatch-panel__inner--color-light');
                } else {
                    $swatchPanelInner.classList.remove('swatch-panel__inner--color-light');
                }

                if ($swatchPanelNumber) {
                    $swatchPanelNumber.innerHTML = colourNumber ? colourNumber.toString().padStart(3, '0') : '';
                }

                if ($swatchPanelName) {
                    $swatchPanelName.innerHTML = colourName ?? '';
                }

                if ($swatchPanelDescription) {
                    $swatchPanelDescription.innerHTML = content ?? '';
                }

                if ($swatchPanelImage) {
                    $swatchPanelImage.innerHTML = image ?? '';
                }

                if ($swatchPanelDeliveryName) {
                    $swatchPanelDeliveryName.innerHTML = delivery?.name ?? '';
                }

                if ($swatchPanelDeliveryPrice) {
                    $swatchPanelDeliveryPrice.innerHTML = delivery?.price_text ?? '';
                }

                if ($swatchPanelDeliveryDuration) {
                    $swatchPanelDeliveryDuration.innerHTML = delivery?.duration ?? '';
                }

                if ($swatchPanelDeliveryDash) {
                    if (delivery?.price_text && delivery?.duration) {
                        $swatchPanelDeliveryDash.classList.remove('swatch-panel__delivery-dash--hide');
                    } else {
                        $swatchPanelDeliveryDash.classList.add('swatch-panel__delivery-dash--hide');
                    }
                }

                $swatchPanelInner.classList.remove('swatch-panel__inner--animate-content-change');

                $swatchPanelAddToCartForm.classList.remove('swatch-panel__add-to-cart-form--loading');

                setTimeout(() => {
                    $swatchPanelAddToCartForm.classList.remove('swatch-panel__add-to-cart-form--no-animation');
                }, 250);
            }, 250);
        };

        const setSwatchNameHeights = () => {
            if (!$swatchNames) return;

            let maxHeight = 0;

            $swatchNames.forEach($swatchName => {
                $swatchName.style.height = '';
            });

            if (window.innerWidth < 680) {
                return;
            }

            $swatchNames.forEach($swatchName => {
                const swatchNameHeight = $swatchName.clientHeight;

                if (swatchNameHeight > maxHeight) {
                    maxHeight = swatchNameHeight;
                }
            });

            $swatchNames.forEach($swatchName => {
                $swatchName.style.height = `${maxHeight}px`;
            });

            if ($swatchPanel) {
                $swatchPanel.style.marginBottom = `${maxHeight}px`;
            }
        }

        const initColourModal = () => {
            if ($swatchBtns) {
                $swatchBtns.forEach($swatchBtn => {
                    const { productId, finishId, colourId, nonce } = $swatchBtn.dataset;

                    $swatchBtn.addEventListener('click', e => {
                        e.preventDefault();

                        $finishColoursSwatchWrap.classList.add('finish-colours-swatch-wrap--loading');
                        
                        cachios.get(GLOBALS.AJAX_URL, {
                            params: {
                                action: 'armourcoat_theme_ajax_get_finish_colour',
                                nonce,
                                product_id: productId,
                                finish_id: finishId,
                                colour_id: colourId,
                                translucent_overlay: $swatchPanelInner?.classList?.contains('swatch-panel__inner--translucent-overlay') ? 1 : 0,
                            }
                        }).then(response => {
                            // Swatch button
                            const $swatchBtnActive = $finishColours.querySelector('.finish-colours-swatch__inner--active');

                            if ($swatchBtnActive) {
                                $swatchBtnActive.classList.remove('finish-colours-swatch__inner--active');
                            }

                            $swatchBtn.classList.add('finish-colours-swatch__inner--active');

                            // Modal
                            setModalContent({
                                colourHex: response?.data?.colourHex,
                                colourId:response?.data?.colourId,
                                colourNumber: response?.data?.colourNumber,
                                colourName: response?.data?.colourName,
                                content: response?.data?.content,
                                delivery: response?.data?.delivery,
                                finishId: response?.data?.finishId,
                                image: response?.data?.image,
                                isInCart: response?.data?.isInCart,
                                textColour: response?.data?.textColour,
                            });

                            // Swatch panel 
                            setSwitchPanelContent({
                                colourHex: response?.data?.colourHex,
                                colourId:response?.data?.colourId,
                                colourNumber: response?.data?.colourNumber,
                                colourName: response?.data?.colourName,
                                content: response?.data?.content,
                                delivery: response?.data?.delivery,
                                finishId: response?.data?.finishId,
                                image: response?.data?.image,
                                isInCart: response?.data?.isInCart,
                                textColour: response?.data?.textColour,
                            });

                            window.history.replaceState(null, document.title, $swatchBtn.href);
                        }).catch(thrown => {
                            console.log(thrown);
                        }).finally(() => {
                            $finishColoursSwatchWrap.classList.remove('finish-colours-swatch-wrap--loading');
                        });
                    });
                });
            }

            if ($modal) {
                $modal.addEventListener('modalclose', () => {
                    const url = new URL(window.location.href);
                    const params = new URLSearchParams(url.search);

                    params.delete('colour');

                    window.history.replaceState(null, document.title, url.pathname + (params.toString() ? '?' + params.toString() : ''));
                });

                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);

                const activeColour = params?.get('colour');

                if (activeColour && window.innerWidth < 680) {
                    openModal($modal);
                }
            }
        };

        const initModalAddToCartForm = () => {
            if (!$modalAddToCartForm) return;

            const addToCart = ({
                nonce,
                productId,
                finishId,
                colourId,
            }) => {
                let loadingAnimating = true;

                setTimeout(() => {
                    loadingAnimating = false;
                }, 250);

                if (addToCartSuccessStateInterval) {
                    clearInterval(addToCartSuccessStateInterval);
                }

                if (addToCartRemoveSuccessStateTimeout) {
                    clearTimeout(addToCartRemoveSuccessStateTimeout);
                }
                
                $modalAddToCartForm.classList.add('finish-colours-modal__add-to-cart-form--loading');
                $swatchPanelAddToCartForm.classList.add('swatch-panel__add-to-cart-form--loading');

                cachios.get(GLOBALS.AJAX_URL, {
                    params: {
                        action: 'armourcoat_theme_ajax_product_add_to_cart',
                        nonce: nonce,
                        product_id: productId,
                        finish_id: finishId,
                        colour_id: colourId,
                        cachbuster: Date.now(),
                    }
                }).then(response => {
                    if (!response?.data?.success) return;

                    addToCartSuccessStateInterval = setInterval(() => {
                        if (!loadingAnimating) {
                            $modalAddToCartForm.classList.add('finish-colours-modal__add-to-cart-form--success');
                            $swatchPanelAddToCartForm.classList.add('swatch-panel__add-to-cart-form--success');

                            addToCartRemoveSuccessStateTimeout = setTimeout(() => {
                                $modalAddToCartForm.classList.remove('finish-colours-modal__add-to-cart-form--loading');
                                $modalAddToCartForm.classList.remove('finish-colours-modal__add-to-cart-form--success');
                                $swatchPanelAddToCartForm.classList.remove('swatch-panel__add-to-cart-form--loading');
                                $swatchPanelAddToCartForm.classList.remove('swatch-panel__add-to-cart-form--success');
                            }, 2000);

                            clearInterval(addToCartSuccessStateInterval);
                        }
                    }, 100);

                    if (response?.data?.cartItemCount) {
                        updateSiteHeaderBasketNumber(response.data.cartItemCount);
                    }
                }).catch(thrown => {
                    console.log(thrown);
                    
                    $modalAddToCartForm.classList.remove('finish-colours-modal__add-to-cart-form--loading');
                    $swatchPanelAddToCartForm.classList.remove('swatch-panel__add-to-cart-form--loading');
                }).finally(() => {
                });
            };

            if ($modalAddToCartForm) {
                $modalAddToCartForm.addEventListener('submit', e => {
                    e.preventDefault();

                    const productId = $modalAddToCartFormProductId?.value;
                    const finishId = $modalAddToCartFormFinishId?.value;
                    const colourId = $modalAddToCartFormColourId?.value;

                    if (!productId || !finishId || !colourId) return;

                    addToCart({
                        nonce: $modalAddToCartFormNonce?.value,
                        productId,
                        finishId,
                        colourId
                    });
                });
            }

            if ($swatchPanelAddToCartForm) {
                $swatchPanelAddToCartForm.addEventListener('submit', e => {
                    e.preventDefault();

                    const productId = $swatchPanelAddToCartFormProductId?.value;
                    const finishId = $swatchPanelAddToCartFormFinishId?.value;
                    const colourId = $swatchPanelAddToCartFormColourId?.value;

                    if (!productId || !finishId || !colourId) return;

                    addToCart({
                        nonce: $swatchPanelAddToCartFormNonce?.value,
                        productId,
                        finishId,
                        colourId
                    });
                });
            }
        };

        const initAddToCartForms = () => {
            if (!$addToCartForms) return;

            $addToCartForms.forEach($addToCartForm => {
                const $addToCartFormNonce = $addToCartForm?.querySelector('[name=armourcoat_theme_product_add_to_cart_wpnonce]');
                const $addToCartFormProductId = $addToCartForm?.querySelector('[name=product_id]');
                const $addToCartFormColourId = $addToCartForm?.querySelector('[name=colour_id]');
                
                $addToCartForm.addEventListener('submit', e => {
                    e.preventDefault();

                    const productId = $addToCartFormProductId?.value;
                    const colourId = $addToCartFormColourId?.value;

                    if (!productId || !colourId) return;

                    let loadingAnimating = true;

                    setTimeout(() => {
                        loadingAnimating = false;
                    }, 250);

                    if (addToCartSuccessStateInterval) {
                        clearInterval(addToCartSuccessStateInterval);
                    }
                        
                    if (addToCartRemoveSuccessStateTimeout) {
                        clearTimeout(addToCartRemoveSuccessStateTimeout);
                    }
                    
                    $addToCartForm.classList.add('finish-grid-colour__add-to-cart-form--loading');

                    cachios.get(GLOBALS.AJAX_URL, {
                        params: {
                            action: 'armourcoat_theme_ajax_product_add_to_cart',
                            nonce: $addToCartFormNonce.value,
                            product_id: productId,
                            colour_id: colourId,
                            cachbuster: Date.now(),
                        }
                    }).then(response => {
                        if (!response?.data?.success) return;

                        addToCartSuccessStateInterval = setInterval(() => {
                            if (!loadingAnimating) {
                                $addToCartForm.classList.add('finish-grid-colour__add-to-cart-form--success');

                                addToCartRemoveSuccessStateTimeout = setTimeout(() => {
                                    $addToCartForm.classList.remove('finish-grid-colour__add-to-cart-form--success');
                                    $addToCartForm.classList.remove('finish-grid-colour__add-to-cart-form--loading');
                                }, 2000);
    
                                clearInterval(addToCartSuccessStateInterval);
                            }
                        }, 100);

                        if (response?.data?.cartItemCount) {
                            updateSiteHeaderBasketNumber(response.data.cartItemCount);
                        }
                    }).catch(thrown => {
                        console.log(thrown);
                        
                        $addToCartForm.classList.remove('finish-grid-colour__add-to-cart-form--loading');
                    }).finally(() => {
                    });
                });
            });
        };

        window.addEventListener('resize', () => {
            setSwatchNameHeights();
        });

        initCarousel();
        initColourModal();
        initModalAddToCartForm();
        setSwatchNameHeights();
        initAddToCartForms();
    });
})();
